import '../../core/components/app-root/AppRoot.css';
import '../../styles/field.css';
import '../../styles/textStyle.css';
import '../../forms/hooks/useAutofillEvent.css';
import '../../forms/_base-input/BaseInput.css';
import '../../forms/forms-core/components/form-field-messages/FormFieldMessageItem.css';
import '../../forms/forms-core/components/form-field-messages/FormFieldMessages.css';
import '../../forms/forms-core/components/form-field/FormField.css';
import './InputGroup.css';
export var inputGroup = '_1x4bl8z1-3-15-1';
export var inputGroupClassName = 'strato-inputgroup';